import React from "react";

const LoadingToRealTransitionWrapper = ({
  isLoading,
  children,
  ghost,
  className = "",
  style = {},
  disableDefaultStyles = false,
}) => {
  // Retain existing behavior: pass style through unless default styles are disabled
  const wrapperStyle = disableDefaultStyles ? {} : style;

  return (
    <div className={`transition-container ${className}`}>
      {isLoading ? (
        <div className="fade-wrapper" key="ghost-wrapper" style={wrapperStyle}>
          {ghost}
        </div>
      ) : (
        <div className="fade-wrapper" key="real-wrapper" style={wrapperStyle}>
          {children}
        </div>
      )}
    </div>
  );
};

export default LoadingToRealTransitionWrapper;
